<template>
    <div>
        <v-simple-table class="table-layout pa-5 table-secondary mt-7">
            <tr>
                <th></th>
                <th>Tổng</th>
                <th>Thành công</th>
                <th>Lỡ</th>
            </tr>
            <tr>
                <td>Tổng số cuộc gọi đi</td>
                <td>{{ _.get(reports, 'totalOutGoing', 0) }}</td>
                <td>{{ _.get(reports, 'totalOutGoingSuccess', 0) }}</td>
                <td>{{ _.get(reports, 'totalOutGoingMiss', 0) }}</td>
            </tr>
            <tr>
                <td>Tổng số cuộc gọi đến</td>
                <td>{{ _.get(reports, 'totalInComing', 0) }}</td>
                <td>{{ _.get(reports, 'totalInComingSuccess', 0) }}</td>
                <td>{{ _.get(reports, 'totalInComingMiss', 0) }}</td>
            </tr>
            <tr>
                <td>Tổng số phút gọi đi</td>
                <td>{{ (+_.get(reports, 'totalDuration', 0)  / 60).toFixed(2) }}</td>
                <td>{{ (+_.get(reports, 'totalSuccessDuration', 0)  / 60).toFixed(2) }}</td>
                <td>{{ (+_.get(reports, 'totalMissDuration', 0)  / 60).toFixed(2) }}</td>
            </tr>
        </v-simple-table>
    </div>
</template>
<script>
    export default {
        props: {
            reports: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
            }
        },
    }
</script>
